import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';
import { LoginModalComponent } from './login-modal.component';
import { TranslateModule } from '@ngx-translate/core';


@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        LoginModalComponent,
        TranslateModule.forChild()
    ],
    declarations: [
    ],
    exports: [
        LoginModalComponent
    ]
})
export class LoginModalModule { }
